import React from 'react';
import { useFormContext } from '@/context/FormContext';
import HandleAiAgentAutofill from './HandleAiAgentAutofill';

type Props = {
  questionnaireId: string;
  onStartAgent: Parameters<typeof HandleAiAgentAutofill>[0]['onStartAgent'];
};

const HandleAiAgentAutofills: React.FC<Props> = ({ questionnaireId, onStartAgent }) => {
  const {
    aiAgents,
    aiAgentsReadyToRun,
  } = useFormContext();

  if (!aiAgentsReadyToRun || !aiAgents || aiAgents.length === 0) {
    return <></>;
  }

  return (
    <>
      {
        aiAgents.map((agent) => (
          <HandleAiAgentAutofill
            key={agent.id}
            aiAgent={agent}
            questionnaireId={questionnaireId}
            onStartAgent={onStartAgent}
          />
        ))
      }
    </>
  );
};

export default HandleAiAgentAutofills;
